import { HANDLER_NOTE_MAX_LENGTH } from './constants';

/** How much of the limit a note uses before its box starts counting its characters. */
const COUNTED_FROM_SHARE = 0.8;

const formatCount = (count: number): string => count.toLocaleString('en-US');

/**
 * The count under a handler's note once it nears the limit, "4,001 / 5,000", and nothing before:
 * a count the note is nowhere near is noise.
 */
export const handlerNoteCounter = (note: string): string | undefined =>
  note.length > HANDLER_NOTE_MAX_LENGTH * COUNTED_FROM_SHARE
    ? `${formatCount(note.length)} / ${formatCount(HANDLER_NOTE_MAX_LENGTH)}`
    : undefined;
